import { render, staticRenderFns } from "./DepositStats.vue?vue&type=template&id=06380a20&scoped=true"
import script from "./DepositStats.vue?vue&type=script&lang=js"
export * from "./DepositStats.vue?vue&type=script&lang=js"
import style0 from "./DepositStats.vue?vue&type=style&index=0&id=06380a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06380a20",
  null
  
)

export default component.exports